import HttpClient from "shared/repositories/HttpClient";
import { GetFreeFortuneDivinationRes } from "shared/types";

export class FreeFortuneDivinationRepository {
  private getPath(id: number) {
    return id ? `/free_fortune/divinations/${id}` : null;
  }

  public get(id: number) {
    const path = this.getPath(id);

    return {
      path,
      data: () =>
        HttpClient.miror
          .get<GetFreeFortuneDivinationRes>(path)
          .then((res) => res.data),
    };
  }
}
